
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as exposed from '../exposed'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Request} from '../core/Request';
import {FieldModelRequest} from '../core/Request';
import {AccountUpdateResponse} from './AccountUpdateResponse';
import {ReportsSubscriptionType} from '../core/ReportsSubscriptionType';
import {FieldModelReportsSubscriptionType} from '../core/ReportsSubscriptionType';

/**
 * AccountUpdateRequest struct
 */
class AccountUpdateRequest extends Request {
  /**
   * Initialize struct
   * @param {!Request=} parent
   * @param {ReportsSubscriptionType=} newReportsSubscriptionType
   * @param {number=} newDisabledEventTypesMask
   * @param {string=} newLanguageName
   * @constructor
   */
  constructor (parent = new Request(), newReportsSubscriptionType = null, newDisabledEventTypesMask = null, newLanguageName = null) {
    super()
    super.copy(parent)
    this.NewReportsSubscriptionType = newReportsSubscriptionType
    this.NewDisabledEventTypesMask = newDisabledEventTypesMask
    this.NewLanguageName = newLanguageName
  }

  /**
   * Copy struct (shallow copy)
   * @this {!AccountUpdateRequest}
   * @param {!AccountUpdateRequest} other Other struct
   * @returns {!AccountUpdateRequest} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.NewReportsSubscriptionType != null) {
      this.NewReportsSubscriptionType = ReportsSubscriptionType.fromObject(other.NewReportsSubscriptionType)
    } else {
      this.NewReportsSubscriptionType = null
    }
    if (other.NewDisabledEventTypesMask != null) {
      this.NewDisabledEventTypesMask = UInt64.fromNumber(other.NewDisabledEventTypesMask)
    } else {
      this.NewDisabledEventTypesMask = null
    }
    if (other.NewLanguageName != null) {
      this.NewLanguageName = other.NewLanguageName
    } else {
      this.NewLanguageName = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!AccountUpdateRequest}
   * @returns {!AccountUpdateRequest} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new AccountUpdateRequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new AccountUpdateRequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!AccountUpdateRequest}
   * @param {!AccountUpdateRequest} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof AccountUpdateRequest)) {
      throw new TypeError('Instance of AccountUpdateRequest is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!AccountUpdateRequest}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      NewReportsSubscriptionType: ((this.NewReportsSubscriptionType != null) ? this.NewReportsSubscriptionType : null),
      NewDisabledEventTypesMask: ((this.NewDisabledEventTypesMask != null) ? this.NewDisabledEventTypesMask.toNumber() : null),
      NewLanguageName: ((this.NewLanguageName != null) ? this.NewLanguageName : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return AccountUpdateRequest.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!AccountUpdateRequest} other Object value
   * @returns {!AccountUpdateRequest} Created struct
   */
  static fromObject (other) {
    return new AccountUpdateRequest().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!AccountUpdateRequest}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return AccountUpdateRequest.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!AccountUpdateRequest}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 5160
  }
}

export { AccountUpdateRequest };

/**
 * Fast Binary Encoding AccountUpdateRequest field model
 */
class FieldModelAccountUpdateRequest extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelRequest(buffer, 4 + 4)
    this.NewReportsSubscriptionType = new fbe.FieldModelOptional(new FieldModelReportsSubscriptionType(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.NewDisabledEventTypesMask = new fbe.FieldModelOptional(new fbe.FieldModelUInt64(buffer, this.NewReportsSubscriptionType.fbeOffset + this.NewReportsSubscriptionType.fbeSize), buffer, this.NewReportsSubscriptionType.fbeOffset + this.NewReportsSubscriptionType.fbeSize)
    this.NewLanguageName = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.NewDisabledEventTypesMask.fbeOffset + this.NewDisabledEventTypesMask.fbeSize), buffer, this.NewDisabledEventTypesMask.fbeOffset + this.NewDisabledEventTypesMask.fbeSize)
  }

  /**
   * Get the core.Request field model
   * @this {!FieldModelAccountUpdateRequest}
   * @returns {!FieldModelRequest} core.Request field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelAccountUpdateRequest}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelAccountUpdateRequest}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.NewReportsSubscriptionType.fbeSize + this.NewDisabledEventTypesMask.fbeSize + this.NewLanguageName.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelAccountUpdateRequest}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.NewReportsSubscriptionType.fbeExtra + this.NewDisabledEventTypesMask.fbeExtra + this.NewLanguageName.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelAccountUpdateRequest}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelAccountUpdateRequest.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelAccountUpdateRequest}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 5160
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelAccountUpdateRequest}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelAccountUpdateRequest}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.NewReportsSubscriptionType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewReportsSubscriptionType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewReportsSubscriptionType.fbeSize

    if ((fbeCurrentSize + this.NewDisabledEventTypesMask.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewDisabledEventTypesMask.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewDisabledEventTypesMask.fbeSize

    if ((fbeCurrentSize + this.NewLanguageName.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewLanguageName.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewLanguageName.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelAccountUpdateRequest}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelAccountUpdateRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelAccountUpdateRequest}
   * @param {!AccountUpdateRequest} fbeValue Default value, defaults is new AccountUpdateRequest()
   * @returns {!AccountUpdateRequest} AccountUpdateRequest value
   */
  get (fbeValue = new AccountUpdateRequest()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelAccountUpdateRequest}
   * @param {!AccountUpdateRequest} fbeValue AccountUpdateRequest value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.NewReportsSubscriptionType.fbeSize) <= fbeStructSize) {
      fbeValue.NewReportsSubscriptionType = this.NewReportsSubscriptionType.get()
    } else {
      fbeValue.NewReportsSubscriptionType = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewReportsSubscriptionType.fbeSize

    if ((fbeCurrentSize + this.NewDisabledEventTypesMask.fbeSize) <= fbeStructSize) {
      fbeValue.NewDisabledEventTypesMask = this.NewDisabledEventTypesMask.get()
    } else {
      fbeValue.NewDisabledEventTypesMask = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewDisabledEventTypesMask.fbeSize

    if ((fbeCurrentSize + this.NewLanguageName.fbeSize) <= fbeStructSize) {
      fbeValue.NewLanguageName = this.NewLanguageName.get()
    } else {
      fbeValue.NewLanguageName = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewLanguageName.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelAccountUpdateRequest}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelAccountUpdateRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelAccountUpdateRequest}
   * @param {!AccountUpdateRequest} fbeValue AccountUpdateRequest value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelAccountUpdateRequest}
   * @param {AccountUpdateRequest} fbeValue AccountUpdateRequest value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.NewReportsSubscriptionType.set(fbeValue.NewReportsSubscriptionType)
    this.NewDisabledEventTypesMask.set(fbeValue.NewDisabledEventTypesMask)
    this.NewLanguageName.set(fbeValue.NewLanguageName)
  }
}

export { FieldModelAccountUpdateRequest };

/**
 * Fast Binary Encoding AccountUpdateRequest model
 */
class AccountUpdateRequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelAccountUpdateRequest(this.buffer, 4)
  }

  /**
   * Get the AccountUpdateRequest model
   * @this {!AccountUpdateRequestModel}
   * @returns {!FieldModelAccountUpdateRequest} model AccountUpdateRequest model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!AccountUpdateRequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!AccountUpdateRequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return AccountUpdateRequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!AccountUpdateRequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelAccountUpdateRequest.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!AccountUpdateRequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!AccountUpdateRequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!AccountUpdateRequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!AccountUpdateRequestModel}
   * @param {!AccountUpdateRequest} value AccountUpdateRequest value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!AccountUpdateRequestModel}
   * @param {!AccountUpdateRequest} value AccountUpdateRequest value, defaults is new AccountUpdateRequest()
   * @return {!object} Deserialized AccountUpdateRequest value and its size
   */
  deserialize (value = new AccountUpdateRequest()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new AccountUpdateRequest(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new AccountUpdateRequest(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!AccountUpdateRequestModel}
   * @param {!number} prev Previous AccountUpdateRequest model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { AccountUpdateRequestModel };
AccountUpdateRequest.__has_response = true;
AccountUpdateRequest.__response_class = AccountUpdateResponse;
